import { Box } from '@mui/joy';
import { states } from '../../lib/states';
import { State, StateProps } from './State';

export interface CountryProps {
	includeLabels?: boolean;
	active?: string[];
	available?: string[];
	activeColor?: StateProps['activeColor'];
	animationDelay?: StateProps['animationDelay'];
	onStateClick?: (state: string) => void;
	largeCountry?: boolean;
}

export const Country = ({
	includeLabels,
	active,
	available,
	activeColor,
	onStateClick,
	animationDelay,
	largeCountry
}: CountryProps) => {
	return (
		<Box
			sx={{
				display: 'grid',
				gridTemplateRows: 'repeat(8, 1fr)', // 8 rows
				gridTemplateColumns: 'repeat(11, 1fr)', // 11 columns
				columnGap: {
					xs: includeLabels ? '2.0px' : largeCountry ? '2.43px' : '1.89px',
					sm: includeLabels ? '3.27px' : largeCountry ? '2.43px' : '1.89px',
					md: includeLabels ? '5.6px' : largeCountry ? '2.43px' : '1.89px'
				},
				rowGap: {
					xs: includeLabels ? '2.0px' : largeCountry ? '2.43px' : '1.89px',
					sm: includeLabels ? '3.27px' : largeCountry ? '2.43px' : '1.89px',
					md: includeLabels ? '4.5px' : largeCountry ? '2.43px' : '1.89px'
				},
				marginLeft: 0,
				flexGrow: 0
			}}
		>
			{Array.from({ length: 8 }, (_, rowIndex) =>
				Array.from({ length: 11 }, (_, colIndex) => {
					const state = states.find(
						(state) => state.y === 8 - rowIndex && state.x === colIndex + 1
					);
					if (!state) return <div key={`${rowIndex}-${colIndex}`}></div>;
					return (
						<State
							animationDelay={animationDelay}
							key={`${rowIndex}-${colIndex}`}
							label={includeLabels ? state?.label : undefined}
							active={active ? active.includes(state?.label) : false}
							available={available ? available.includes(state?.label) : false}
							activeColor={activeColor}
							tooltipLabel={
								available && available.includes(state?.label)
									? state.longLabel
									: undefined
							}
							onClick={() => {
								onStateClick
									? onStateClick(state.label.toLowerCase())
									: undefined;
							}}
							largeCountry={largeCountry}
						/>
					);
				})
			)}
		</Box>
	);
};
